module.exports = __webpack_public_path__ + "img/slide01.35f04aa9.png";